import { Box } from "@chakra-ui/react";
import { ItineratorItineraryList, itineraryApi } from "itinerator-api";
import { get } from "lodash";
import Head from "next/head";
import {
  FifthPanel,
  FirstPanel,
  FooterPanel,
  FourthPanel,
  SecondPanel,
  SixthPanel,
  ThirdPanel,
} from "~/components/Home";
import { Footer } from "~/components/Layout";
import { GetStrapiServerSideProps, PageProps, getStrapiPage } from "~/strapi";
import { NextPageWithLayout } from "~/types";
type Props = PageProps<{
  itineraries: ItineratorItineraryList;
}>;

const Home: NextPageWithLayout<Props> = ({ itineraries, pageData }: Props) => {
  const logo = get(
    pageData,
    "seo.metaImage.data.attributes.url",
    "https://hwy3bc.ca/meta_image.jpg"
  );

  return (
    <>
      <Head>
        <script
          type="application/ld+json"
          dangerouslySetInnerHTML={{
            __html: JSON.stringify({
              "@context": "http://schema.org",
              "@type": "Organization",
              name: "Highway 3",
              url: "https://hwy3bc.ca",
              logo,
            }),
          }}
        />
      </Head>
      <Box display="none">
        <h1>
          Highway 3, get tips on all the hidden gems and stories, and find
          inspiration from our themed road trips as you plan your next
          adventure!  
        </h1>
      </Box>
      <FirstPanel />
      <SecondPanel />
      {/* <ThirdPanel /> */}
      <FourthPanel itineraries={itineraries} />
      <FifthPanel />
      <SixthPanel />
      <Box bg="gray.900">
        <Footer />
      </Box>
    </>
  );
};

Home.layoutOptions = { showFooter: false };

export const getServerSideProps: GetStrapiServerSideProps<Props> = async (
  context
) => {
  const pageData = await getStrapiPage({ id: "home" });
  const itineraries = await itineraryApi.getItineraries();
  return { props: { pageData, itineraries } };
};

export default Home;
